// removed by extract-text-webpack-plugin
module.exports = {"container":"_2zbKZA9","containerWrapper":"_1G5WFnO","slideUp":"_1TLIkUE","titleBarWrapper":"pd-tTev","contentBarWrapper":"_2RzbZoX","titleBar":"_1Mm24sv","title":"_1YuC05z","closeButton":"_1jxNAGm","contentBar":"_1jlh44H"};


//////////////////
// WEBPACK FOOTER
// ./template/components/WelcomeMat/WelcomeMat.css
// module id = ./template/components/WelcomeMat/WelcomeMat.css
// module chunks = client.sitechrome